/**
 * Normalize Konva.Node geometry to core format.
 * For svg-shape, pass skipMutate: true so the node is not mutated; only the computed
 * geometry is returned. The next sync will apply the correct attrs from state and avoid
 * the shape reverting to its previous size after drag/transform.
 *
 * @param {Konva.Node} node
 * @param {{ skipMutate?: boolean }} [options] - If true, do not mutate node (use for svg-shape).
 */
export function normalizeGeometry(node, options = {}) {
    const scaleX = node.scaleX()
    const scaleY = node.scaleY()
    const width = Math.max(node.width() * scaleX, 1)
    const height = Math.max(node.height() * scaleY, 1)

    if (!options.skipMutate) {
        node.scaleX(1)
        node.scaleY(1)
        node.width(width)
        node.height(height)
    }

    return {
        x: node.x(),
        y: node.y(),
        width,
        height,
        rotation: node.rotation(),
    }
}
